'use strict';

import baseApi from './base-api';
import moment from 'moment'

export default class TheaterApi extends baseApi {  
  getAllRegions(productSid = '') {
    let params = {'product_sid': productSid},
        resurt = this.postApiRequest('/theaters/regions', params);
        return resurt;
  }
  getPrefecturesOfRegion(region, productSid = '') {
    let params = {'product_sid': productSid},
        resurt = this.postApiRequest(`/theaters/prefectures/${encodeURI(region)}`, params);
        return resurt;
  }
  getTheaterAreanames(prefecture, productSid = '') {
    let params = {'prefecture': prefecture, 'product_sid': productSid},
        resurt = this.postApiRequest(`/theaters/areanames`, params);
        return resurt;
  }
  // エリア絞り込みで映画館一覧取得
  // ページネーションしない前提で100件取得している
  getTheaters(area, long = 0, lat = 0, page = 1, perPage = 100) {
    let params = {
          'areaname': area,
          'long': long,
          'lat': lat,
          'page': page,
          'par_page': perPage,
        },
        resurt = this.postApiRequest(`/theaters/filter`, params);        
        return resurt;
  }
  // 映画館で公開している作品一覧取得
  // ページネーションしない前提で100件取得している
  getTheaterProducts(theaterId, page = 1, perPage = 100) {
    let params = {
          'page': page,
          'par_page': perPage,
        },
        resurt = this.getApiRequest(`/theaters/${theaterId}/products`, params);        
        return resurt;
  }
  getTheaterShowtimes(theaterId) {
    let date = moment().format('YYYY-MM-DD'),
        resurt = this.getApiRequest(`/theaters/${theaterId}/${date}/showtimes`, {});        
        return resurt;
  }
}